export const getDashArray = (width: number, height: number) => {
  return `0, ${width}, ${height}, ${width + height}`;
};
